module.exports = __webpack_public_path__ + "img/category_5.b26a6a8f.svg";